import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { CustomGridSettings } from "./grid.models";

@Injectable({
    providedIn: 'root'
  })
  export class CustomGridService {
  
    private _gridSettings$ = new BehaviorSubject<CustomGridSettings>(new CustomGridSettings());
  
    constructor() { }
  
    get gridSettings$() { return this._gridSettings$.asObservable(); }
  
    setGridSettings(grid: CustomGridSettings) {
      this._gridSettings$.next(grid || new CustomGridSettings());
    }
  
    reset() {
      this._gridSettings$.next(new CustomGridSettings());
    }
  }
  